var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "modal-lite-holder" } },
    [
      _c("ModalRequestCustomDesign"),
      _vm._v(" "),
      _c("ModalFeedback"),
      _vm._v(" "),
      _c("ModalGetPrice"),
      _vm._v(" "),
      _c("ModalShowPhotoInResult"),
      _vm._v(" "),
      _c("modals-container")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }